/**
 * Bridge between the axios interceptor and the React notification layer.
 *
 * `services/api.js` is a plain module, so it cannot call `useNotification()`. It
 * publishes here instead, and `components/ApiErrorNotifier` — which is mounted inside
 * NotificationProvider — turns the event into a toast.
 */

const listeners = new Set();

export const onApiError = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const emitApiError = (event) => {
  listeners.forEach((listener) => {
    try {
      listener(event);
    } catch (e) {
      // A listener must never swallow the request error that triggered it.
    }
  });
};
